module.exports = __webpack_public_path__ + "img/p2.2bb050ef.png";